import { useEffect, useState } from "react";
import ProfileService from "../../../../../services/Profile";
import { useNavigate } from "react-router-dom";
import { FiPlus } from "react-icons/fi";

export default function MyPackages() {
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    async function getMyPackages() {
        try {
            setLoading(true);

            const res = await ProfileService.getMyPackages();

            if (res?.status === 200) {
                setPackages(res.data?.data || []);
            }
        } catch (error) {
            console.error("Get my packages error:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getMyPackages();
    }, []);

    if (loading) {
        return <p className="text-center text-gray-500 py-6">Loading...</p>;
    }

    return (
        <div className="flex flex-col gap-3">

            <div className="flex justify-center mb-4">
                <button
                    onClick={() => navigate("/createPackage")}
                    className="inline-flex items-center gap-1.5 rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:opacity-90 active:scale-95 transition"
                >
                    <FiPlus size={16} />
                    Create Package
                </button>
            </div>
            <div className="mb-24">
            {packages.length === 0 ? (
                <p className="text-center text-gray-500 py-6">
                    You haven't created any packages yet.
                </p>
            ) : (
                packages.map((item) => (
                    <div
                        key={item._id}
                        className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4  flex flex-col gap-4"
                    >
                        {/* Header */}
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
                                    <i className="text-primary text-xl">
                                        {item.packageIcon}
                                    </i>
                                </div>

                                <div>
                                    <h3 className="font-bold text-gray-900">
                                        {item.name}
                                    </h3>

                                    <p className="text-xs text-gray-500">
                                        {item.packageBadge}
                                    </p>
                                </div>
                            </div>

                            <span className={`text-xs font-semibold px-3 py-1 rounded-full ${item.status === "approved"
                                    ? "bg-green-100 text-green-700"
                                    : item.status === "pending"
                                        ? "bg-yellow-100 text-yellow-700"
                                        : "bg-red-100 text-red-700"
                                }`}>
                                {item.status}
                            </span>
                        </div>

                        {/* Description */}
                        <p className="text-sm text-gray-500">
                            {item.description}
                        </p>

                        {/* Price & Duration */}
                        <div className="grid grid-cols-2 gap-3">
                            <div className="bg-gray-50 rounded-xl p-3">
                                <p className="text-xs text-gray-500">Price</p>
                                <p className="font-bold text-gray-900 mt-1">
                                    ${item.price}
                                </p>
                            </div>

                            <div className="bg-gray-50 rounded-xl p-3">
                                <p className="text-xs text-gray-500">Duration</p>
                                <p className="font-bold text-gray-900 mt-1">
                                    {item.duration?.days} Days
                                </p>
                            </div>
                        </div>
                    </div>
                ))
            )}
            </div>
        </div>
    );
}